/** Short-lived object URLs from the Academy's authenticated lesson assets. */
const active = new Set<string>()

export function registerLessonBlob(url: string): void {
  active.add(url)
}

export function revokeLessonBlob(url: string): void {
  if (active.delete(url)) URL.revokeObjectURL(url)
}

/** Runs synchronously on auth/principal/tier changes, before React rerenders. */
export function revokeAllLessonBlobs(): void {
  for (const url of active) URL.revokeObjectURL(url)
  active.clear()
}
